import Constants from 'Constants'

/**
 * Appoint de l'écran des applications tierces pour les fournisseurs de modèles de langage : leur clé
 * s'y saisit comme les autres, mais l'utilisateur doit pouvoir la valider avant de s'en servir.
 *
 * La clé saisie ne fait que transiter vers l'API, qui ne la renvoie jamais en clair : c'est son
 * masque qui revient à la lecture.
 */
export default {
	methods: {
		// Valide une clé auprès de son fournisseur. Sans clé transmise, ou si le champ n'a pas été
		// modifié depuis son affichage masqué, c'est la clé déjà enregistrée que le serveur teste.
		testLLMKey: async function(provider, api_key) {
			const url = Constants.LLM_TEST_URL + "?licence_key=" + Constants.USER_LICENCE_KEY

			const result = await this.$request.request_post_api("LLMConfigMixin::testLLMKey", url, { provider, api_key }, false)
			.catch(error => {
				// L'objet d'erreur axios porte le corps de la requête, donc la clé en clair : on ne
				// journalise que le statut HTTP.
				console.error("LLMConfigMixin::testLLMKey => ERROR", error.response && error.response.status)
				return null
			})

			if(result) return result.retour
			return null
		}
	}
}
